import React, { useState } from "react";
import NovelTags from "./NovelTags";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import Loadinguser from "../../../components/Loadingnovel";
import Loadingnovel from "../../../components/Loadingnovel";
import ReportNovel from "./Report Novel/ReportNovel";
import { useDispatch } from "react-redux";
import { updatelocalUser } from "../../../3- actions/users";
import { unwrapResult } from "@reduxjs/toolkit";
import { updateCurrentNovel } from "../../../3- actions/novels";

import { FaHeartBroken } from "@react-icons/all-files/fa/FaHeartBroken";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { AiFillFlag } from "@react-icons/all-files/ai/AiFillFlag";
import { ImBookmarks } from "@react-icons/all-files/im/ImBookmarks";
import { Helmet } from "react-helmet";

function NovelHeader({
  LocalUser,
  currentNovel,
  currentUserNovel,
  setPopUp,
  setInterfaces,
}) {
  const dispatch = useDispatch();
  const localuser = JSON.parse(localStorage.getItem("profile"));
  const [loading, setLoading] = useState(false);
  // get pop up with id on it of whom you want to report (novel)
  const [reportNovel, setReportNovel] = useState(false);
  const validity = LocalUser?.favoriteNovels;
  const novelLikes = currentNovel?.novels?.likes;

  const [ref1, inView1] = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });

  const handleClickReport = () => {
    if (localuser) {
      setReportNovel(true);
    } else {
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  // librarySystem
  const handleClickUpdate = () => {
    if (localuser) {
      setLoading(true);
      // push to Novel_id to my old array
      if (validity?.includes(currentNovel?.novels?._id)) {
        const FavoriteDataObject = {
          userId: LocalUser._id,
          obj: {
            favoriteNovels: validity.filter(
              (favorited) => favorited !== currentNovel?.novels?._id
            ),
          },
        };
        dispatch(updatelocalUser(FavoriteDataObject))
          .then(unwrapResult)
          .then(() => {
            setLoading(false);
          });
      } else {
        const FavoriteDataObject = {
          userId: LocalUser._id,
          obj: {
            favoriteNovels: [...validity, currentNovel?.novels?._id],
          },
        };
        dispatch(updatelocalUser(FavoriteDataObject))
          .then(unwrapResult)
          .then(() => {
            setLoading(false);
          });
      }
    } else {
      setLoading(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  // likeSystem
  const handleClickUpdateNovel = () => {
    if (localuser) {
      if (novelLikes.includes(LocalUser?._id)) {
        const novelLikesObj = {
          userId: currentNovel?.novels?._id,
          obj: {
            likes: novelLikes.filter((like) => like !== LocalUser?._id),
          },
        };
        dispatch(updateCurrentNovel(novelLikesObj));
      } else {
        const novelLikesObj = {
          userId: currentNovel?.novels?._id,
          obj: {
            likes: [...novelLikes, LocalUser?._id],
          },
        };
        dispatch(updateCurrentNovel(novelLikesObj));
      }
    } else {
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  // numbersLogic
  function numbersLogic(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    if (num >= 10 && num <= 99) {
      return "0" + num;
    }
    if (num <= 9) {
      return "00" + num;
    }
    return num;
  }
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Read ${currentNovel?.novels?.title} - EyeNovel`}</title>
        <meta
          name="description"
          content={`Read ${currentNovel?.novels?.title} written by the author ${currentUserNovel?.users?.firstName} on EyeNovel, ✓ Newest updated ✓ All rights reserved`}
        />

        {/* <!-- Google / Search Engine Tags --> */}
        <meta
          itemprop="name"
          content={`Read ${currentNovel?.novels?.title} - EyeNovel`}
        />
        <meta
          itemprop="description"
          content={`Read ${currentNovel?.novels?.title} written by the author ${currentUserNovel?.users?.firstName} on EyeNovel, ✓ Newest updated ✓ All rights reserved`}
        />
        <meta itemprop="image" content={currentNovel?.novels?.selectedFile} />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:url" content="https://eyenovel.netlify.app" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`Read ${currentNovel?.novels?.title} - EyeNovel`}
        />
        <meta
          property="og:description"
          content={currentNovel?.novels?.description}
        />
        <meta
          property="og:image"
          content={currentNovel?.novels?.selectedFile}
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`Read ${currentNovel?.novels?.title} - EyeNovel`}
        />
        <meta
          name="twitter:description"
          content={currentNovel?.novels?.description}
        />
        <meta
          name="twitter:image"
          content={currentNovel?.novels?.selectedFile}
        />
      </Helmet>
      <div className="h-auto w-full flex relative px-[15px] md:px-0">
        <div className="full-width h-auto">
          <div className="bg-secondary/90  backdrop-blur-[10px] z-50 w-full h-full absolute"></div>
          <div className=" absolute w-full h-full m-auto">
            <img
              className="object-cover h-full w-full  z-10"
              src={currentNovel?.novels?.selectedFile}
              alt={currentNovel?.novels?.title}
            />
          </div>
        </div>
        <div
          title="Report Novel"
          onClick={handleClickReport}
          className="w-[52px] h-[52px] flex justify-center items-center text-tertiary cursor-pointer hover:bg-primary/90 duration-500 ease-in-out bg-primary z-50 absolute bottom-0 translate-y-1/2 md:right-0 right-[15px]"
        >
          <AiFillFlag />
        </div>
        <div className="relative px-0 lg:px-10 xl:px-20 z-50 w-full h-auto my-28 flex flex-col lg:flex-row justify-center sm:items-center lg:items-start m-auto gap-x-10 xl:gap-x-20 gap-y-10 lg:gap-y-0">
          {/* user */}
          <div className="relative h-auto lg:w-fit max-w-full flex-none flex-row-reverse justify-start items-start block lg:flex  gap-x-8 capitalize">
            <div className="relative z-30 flex flex-col gap-y-4">
              <div
                ref={ref1}
                className=" h-full w-full sm:max-w-[280px] lg:w-[280px] sm:h-[420px]"
              >
                {inView1 ? (
                  <div className="createrectangle duration-500 ease-in-out opacity-100 w-full h-full object-cover">
                    <img
                      className="createrectangle  duration-500 ease-in-out  w-full h-full object-cover"
                      src={currentNovel?.novels?.selectedFile}
                      alt={currentNovel?.novels?.title}
                    />
                  </div>
                ) : (
                  <div className="bg-secondary createrectangle cursor-pointer duration-[0] opacity-20 ease-in-out  flex justify-center items-center  w-full h-full  object-cover">
                    <Loadingnovel />
                  </div>
                )}
              </div>
              {/* librarySystem */}
              <div>
                <div
                  onClick={handleClickUpdate}
                  className="Purple-btn-effect relative gap-x-4 capitalize group cursor-pointer hover:bg-primary/90 duration-500 ease-in-out text-tertiary bg-primary  flex justify-center items-center  w-full h-[52px] z-[1000]"
                >
                  {validity?.includes(currentNovel?.novels?._id) ? (
                    loading ? (
                      <Loading />
                    ) : (
                      <div
                        title="Remove From Library"
                        className="flex mx-4 justify-center items-center gap-x-4"
                      >
                        <ImBookmarks className="text-[20px] duration-500 ease-in-out" />
                        <h2 className="line-clamp-1 text-[14px] md:text-[16px]">
                          remove From Library
                        </h2>
                      </div>
                    )
                  ) : loading ? (
                    <Loading />
                  ) : (
                    <div
                      title="Add To Library"
                      className="flex mx-4  justify-center items-center gap-x-4"
                    >
                      <ImBookmarks className=" text-[20px]  duration-500 ease-in-out" />
                      <h2 className="line-clamp-1 text-[14px] md:text-[16px]">
                        Add To Library
                      </h2>
                    </div>
                  )}
                </div>
              </div>
              {currentUserNovel.pending === true ? (
                <div className=" absolute top-0 left-1/2 -translate-x-1/2  -translate-y-1/2">
                  <LoadingUserDetails />
                </div>
              ) : (
                <div
                  ref={ref}
                  className=" rounded-full  absolute top-0 left-1/2 -translate-x-1/2  -translate-y-1/2"
                >
                  <Link to={`/users/${currentUserNovel?.users?._id}`}>
                    <div
                      title={currentUserNovel?.users?.firstName}
                      className=" cursor-pointer border-2 w-[55px] h-[55px] border-primary bg-secondary rounded-full"
                    >
                      {inView ? (
                        currentUserNovel?.users?.picture ? (
                          <div className="w-full h-full opacity-100 duration-500 ease-in-out">
                            <img
                              className="w-full h-full object-cover rounded-full "
                              src={currentUserNovel?.users?.picture}
                              alt={currentUserNovel?.users?.firstName}
                            />
                          </div>
                        ) : (
                          <div className="w-full h-full leading-10 flex justify-center items-center bg-primary rounded-full text-tertiary uppercase opacity-100 duration-500 ease-in-out">
                            {currentUserNovel?.users?.firstName &&
                              currentUserNovel?.users?.firstName[0]}
                          </div>
                        )
                      ) : (
                        <div className="flex justify-center items-center h-full w-full rounded-full opacity-80 scale-75 rectangle duration-500 ease-in-out object-cover">
                          <Loadinguser />
                        </div>
                      )}
                    </div>
                  </Link>
                </div>
              )}
            </div>
            {/* likeSystem */}
            <div className="w-full mt-4 lg:mt-0 flex-row lg:flex-col flex justify-center items-center">
              <div
                title="Favorites"
                onClick={handleClickUpdateNovel}
                className="bg-primary hover:bg-primary/90  w-1/2 lg:w-12 text-tertiary relative duration-500 ease-in-out cursor-pointer h-12 flex justify-center items-center"
              >
                <div
                  className={
                    novelLikes?.includes(LocalUser?._id)
                      ? "absolute scale-1 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                      : "absolute scale-0 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  }
                >
                  <FaHeart className="scale-[1.1] md:scale-[1.2] duration-500 ease-in-out" />
                </div>
                <div
                  className={
                    novelLikes?.includes(LocalUser?._id)
                      ? "absolute scale-0 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                      : "absolute scale-1 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  }
                >
                  <FaHeartBroken className="scale-[1.1] md:scale-[1.2] duration-500 ease-in-out " />
                </div>
              </div>
              <div className="bg-primary/80 w-1/2 lg:w-12 text-[14px] md:text-[16px]  text-tertiary h-12 flex justify-center items-center">
                <span className="px-4">{numbersLogic(novelLikes?.length)}</span>
              </div>
            </div>
          </div>
          {/* Novel */}
          <div className="w-full lg:w-[60%] xl:w-[700px] h-full flex gap-y-6 flex-col lg:text-left lg:items-start text-center justify-start items-center text-tertiary">
            <h1 className="break-words w-full font-SoraS text-[20px] md:text-[24px]">
              {currentNovel?.novels?.title?.trim()}
            </h1>
            <div className="flex flex-col gap-y-4 w-full">
              <div className="bg-primary h-[52px] w-full lg:w-fit px-8 flex justify-center items-center capitalize font-SoraR">
                Synopsis
              </div>
              <p className="break-words whitespace-pre-line w-full flex-1 font-SoraR text-[14px] md:text-[16px] px-0 md:px-[20px] lg:px-0">
                {currentNovel?.novels?.description?.trim()}
              </p>
            </div>
            <div className="flex flex-col gap-y-4 w-full lg:w-fit">
              <div className="bg-primary h-[52px] w-full lg:w-fit px-8 flex justify-center items-center capitalize font-SoraR">
                tags
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-4 w-full">
                {currentNovel?.novels?.tags?.map((tag, index) => {
                  return <NovelTags key={index} tag={tag} />;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* report a novel*/}
      <ReportNovel
        currentNovel={currentNovel.novels}
        reportNovel={reportNovel}
        setReportNovel={setReportNovel}
      />
    </div>
  );
}

export default NovelHeader;
function Loading() {
  return (
    <div className="flex justify-center items-center scale-75">
      <div role="status">
        <svg
          aria-hidden="true"
          className="w-8 h-8 text-tertiary animate-spin fill-primary"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
      <span className="pl-4">Loading...</span>
    </div>
  );
}
function LoadingUserDetails() {
  return (
    <div>
      <div
        className="absolute lg:relative lg:-translate-y-0 lg:-translate-x-0 lg:left-0 top-0 -translate-y-[70%] z-[100]   left-1/2 -translate-x-1/2 flex h-fit flex-col justify-start items-center gap-y-1 cursor-pointer"
        role="status"
      >
        <svg
          aria-hidden="true"
          className="w-8 h-8  animate-spin text-gray-600 fill-primary"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}
